module.exports = __webpack_public_path__ + "img/ABR.cead1a82.svg";